import axios from 'axios';

class VideoUploadService {
  static getStatus({ videoId }) {
    return axios.get(`/videos/${videoId}/status`).then(({ data }) => data);
  }
}

export default VideoUploadService;
